module.exports = __webpack_public_path__ + "img/activeicon-relationship_chart_icon.345c85b2.svg";